import { useState } from 'react';

interface FAQ {
  question: string;
  answer: string;
}

const faqData: FAQ[] = [
  {
    question: '啪啪啪在线观看是否安全？',
    answer: '在正规、合法的平台上观看内容是安全的。我们建议用户选择持有合法经营资质的平台，注意保护个人隐私信息，使用安全的网络环境，并遵守相关法律法规。我们提供的内容旨在进行科学的性教育科普，帮助用户建立正确的性观念。',
  },
  {
    question: '如何保护在线观看时的隐私？',
    answer: '保护在线隐私可以通过以下方式：使用隐私浏览模式（无痕模式），启用可靠的VPN服务加密网络流量，定期清理浏览器Cookie和历史记录，避免在不安全的公共Wi-Fi环境下访问敏感内容，以及不向不可信的网站提供个人信息。',
  },
  {
    question: '哪些平台是正规合法的？',
    answer: '正规合法平台通常具备以下特征：拥有ICP备案号和合法经营资质，有明确的用户协议和隐私政策，提供有效的客服联系方式，内容经过审核符合法律法规要求。建议选择知名的大型平台，避免访问来源不明的小网站。',
  },
  {
    question: '未成年人应该如何正确获取性教育知识？',
    answer: '未成年人应在家长或老师的指导下，通过正规渠道获取性教育知识。推荐渠道包括：学校开设的健康教育课程、国家卫生健康委员会发布的科普资料、正规医院和医疗机构的健康教育内容。家长应以开放、科学的态度与孩子沟通性教育话题。',
  },
  {
    question: '发现不良信息应该如何处理？',
    answer: '如果发现违法或不良信息，可以通过以下途径举报：12321网络不良与垃圾信息举报受理中心、中国互联网违法和不良信息举报中心（www.12377.cn）、以及向当地公安机关报案。每个公民都有责任维护清朗的网络空间。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">
            关于在线安全和性教育的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
              >
                <h3 className="font-heading text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.question}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-400"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}